import Vue from 'vue';
import {
  VBtn,
  VBtnToggle,
  VCol,
  VContainer,
  VRow,
  VCard,
  VTextarea,
  VCardActions,
  VSpacer,
  VCardText,
  VSwitch,
  VTooltip,
  VIcon,
} from 'vuetify/lib';
import { mapActions } from 'vuex';
import PendingEvents from '@/components/sports/PendingEventsWidget/PendingEventsWidget';
import PendingMarkets from '@/components/sports/PendingEventsWidget/PendingMarketsWidget';
import EventScores from '@/components/sports/PendingEventsWidget/EventScoresWidget';
import EventResultWidget from '@/components/sports/EventResults';
import { PendingEvent } from '@/types/sports';
import { hasRoles } from '@/utils/auth';

export default Vue.extend({
  data() {
    return {
      eventType: 'event',
      settlementData: 'scores',
      eventComment: '',
      isTrading: false,
      hideEarlySpecialMarketPending: false,
      pendingEvent: null as PendingEvent | null,
    };
  },
  computed: {
    canGrade(): boolean {
      return hasRoles(['sports:operator', 'sports-grading:operator']);
    },
  },
  methods: {
    ...mapActions({
      updatePendingEventComment: 'pendingEvents/updatePendingEventComment',
      getPendingEventsAction: 'pendingEvents/getPendingEvents',
    }),
    selectEvent(pendingEvent: PendingEvent) {
      this.eventComment = '';
      this.pendingEvent = pendingEvent;
    },
    async updatePendingEventCommentAndRefresh(eventId: string, comment: string) {
      await this.updatePendingEventComment({ eventId, comment });
      await this.getPendingEventsAction({
        eventType: this.eventType,
        isTrading: this.isTrading,
        hideEarlySpecialMarketPending: this.hideEarlySpecialMarketPending,
      });
      this.pendingEvent = null;
    },
  },
  render() {
    return (
      <VContainer fluid>
        <VRow class='mt-2 ml-2'>
          <VCol><h1>Pending Events</h1></VCol>
        </VRow >
        <VRow class='mt-2 ml-2 mr-2'>
          <VCol md='6'>
            <VRow>
              <VCol cols='auto'>
                <VBtnToggle vModel={this.eventType} mandatory={true}>
                  <VBtn value='event'>Event</VBtn>
                  <VBtn value='outright'>Outright</VBtn>
                </VBtnToggle>
              </VCol>
              <VCol cols='auto'>
                <VSwitch vModel={this.isTrading} label='Including Trading' inset={true} />
              </VCol>
              <VCol cols='auto'>
                <div class='d-flex align-center'>
                  <VSwitch
                    vModel={this.hideEarlySpecialMarketPending}
                    label='Hide Specials'
                    inset={true}
                  />
                  <VTooltip right scopedSlots={{
                    activator: ({ on }: { on: any }) => {
                      return <VIcon {...{ on }} dense>info</VIcon>;
                    },
                  }}>
                    <span>
                      Hides pending events whose remaining pending selections are all on special markets
                      (e.g. player props), for a configured window after the event starts. Events that
                      haven't started yet, have non-special selections still pending, or are past that
                      window are always shown.
                    </span>
                  </VTooltip>
                </div>
              </VCol>
            </VRow>
            <VRow>
              <PendingEvents
                eventType={this.eventType}
                isTrading={this.isTrading}
                hideEarlySpecialMarketPending={this.hideEarlySpecialMarketPending}
                selectEvent={this.selectEvent}
              />
            </VRow>
            {this.canGrade && this.pendingEvent &&
              <VRow>
                <VContainer fluid>
                  <VCard>
                    <VCardText>
                      <VTextarea
                        v-model={this.eventComment}
                        label='Event Comment'
                      ></VTextarea>
                    </VCardText>
                    <VCardActions>
                      <VSpacer></VSpacer>
                      <VBtn
                        color='green darken-1'
                        text
                        onClick={() => {
                          this.updatePendingEventCommentAndRefresh(
                            this.pendingEvent?.eventId as string,
                            this.eventComment);
                        }}>
                        UPDATE
                      </VBtn>
                    </VCardActions>
                  </VCard>
                </VContainer>
              </VRow>}
          </VCol>

          {this.pendingEvent &&
            <VCol md='6'>
              <VContainer fluid>
                <VRow>
                  <VBtnToggle vModel={this.settlementData} mandatory={true}>
                    <VBtn value='scores'>Scores</VBtn>
                    <VBtn value='results'>Results</VBtn>
                  </VBtnToggle>
                  {
                    this.settlementData === 'scores' ?
                      <EventScores eventId={this.pendingEvent.eventId} sportKey={this.pendingEvent.sportKey} /> :
                      <EventResultWidget eventId={this.pendingEvent.eventId} />
                  }
                </VRow>
                <VRow>
                  <PendingMarkets eventName={this.pendingEvent.name} eventId={this.pendingEvent.eventId} />
                </VRow>
              </VContainer>
            </VCol>
          }
        </VRow >
      </VContainer >
    );
  },
});
